const idList = [
  "TonTon",
  "RooCare",
  "Worthon",
  "ChildSeat",
  "KettleBell-Advanced",
  "KettleBell",
  "Multi-Weight",
  "Corechair",
  "CFL-228",
  "DEX",
  "EZmug",
  "AirMate",
  "DogYearGift",
  "PixoTest",
  "AirMagnum",
  "eSPORT",
  "FlipGaugePump",
  "DAB-Stereo",
  "BikeRepairStand",
  "XEZhead",
  "DuracellHDD",
  "WindLionGod",
  "Rii"
];

function getIDPos(name) {
  const idPos = idList
    .map(item => item === name)
    .findIndex(idx => idx === true);
  return idPos;
}

const productsConfig = [
  {
    id: getIDPos("KettleBell-Advanced"),
    name: "KettleBell-Advanced",
    description: "正球狀競技壺鈴設計可調整8-40磅壺鈴重塊，共八個段數重塊為創新蛋糕式排列鋅壓鑄重塊拉起的重塊為對稱排列",
    cover: ["/img/KettleBell-Advanced/cover.jpg"],
    imgs: [
      "/img/KettleBell-Advanced/1.jpg",
      "/img/KettleBell-Advanced/2.jpg",
      "/img/KettleBell-Advanced/3.jpg",
      "/img/KettleBell-Advanced/4.jpg",
      "/img/KettleBell-Advanced/5.jpg"
    ]
  },
  {
    id: getIDPos("ChildSeat"),
    name: "ChildSeat",
    description:
      "新一代自行車小孩座椅，安全握把可加裝水壺，搭載的自行車後架，可使用前後安全結構鎖固預防鬆脫。",
    cover: ["/img/ChildSeat/cover.jpg"],
    imgs: [
      "/img/ChildSeat/2.jpg",
      "/img/ChildSeat/3.jpg",
      "/img/ChildSeat/4.png",
      "/img/ChildSeat/5.jpg",
      "/img/ChildSeat/6.jpg"
    ]
  },
  {
    id: getIDPos("Corechair"),
    name: "Corechair",
    description:
      "可強化核心肌群的辦公座椅。<br/><br/>透過座椅旁的打氣裝置來調整座椅的穩定度，低壓時使用者須穩定坐姿，來達到強化核心肌群的運動目的，也能保健腰背健康。高壓時就如同舒適的高級辦公座椅。",
    cover: ["/img/Corechair/cover.jpg"],
    imgs: [
      "/img/Corechair/banner.jpg",
      "/img/Corechair/0.jpg",
      "/img/Corechair/1.jpg",
      "/img/Corechair/2.jpg",
      "/img/Corechair/3.jpg",
      "/img/Corechair/4.jpg",
      "/img/Corechair/5.jpg",
      "/img/Corechair/6.jpg",
      "/img/Corechair/7.jpg",
      "/img/Corechair/8.jpg",
      "/img/Corechair/9.jpg",
      "/img/Corechair/10.jpg",
      "/img/Corechair/11.jpg",
      "/img/Corechair/12.jpg",
      "/img/Corechair/13.jpg"
    ]
  },
  {
    id: getIDPos("DEX"),
    name: "DEX",
    description:
      "平價版倒立機，腰部不適者可使用此產品讓腰椎拉開，達到復健與保健的效果",
    cover: ["/img/DEX/cover.jpg"],
    imgs: [
      "/img/DEX/banner.jpg",
      "/img/DEX/2.jpg",
      "/img/DEX/3.jpg",
      "/img/DEX/4.jpg",
      "/img/DEX/5.jpg"
    ]
  },
  {
    id: getIDPos("KettleBell"),
    name: "KettleBell",
    description:
      "七段重塊可調式壺鈴，側身為EVA材質，可配合訓練強度選擇重量6磅到30磅，和壺鈴運動的各種需求，適合居家健身使用",
    cover: ["/img/KettleBell/cover.jpg"],
    imgs: [
      "/img/KettleBell/1.jpg",
      "/img/KettleBell/2.jpg",
      "/img/KettleBell/3.jpg",
      "/img/KettleBell/4.jpg",
      "/img/KettleBell/5.jpg",
      "/img/KettleBell/6.jpg",
      "/img/KettleBell/7.jpg",
      "/img/KettleBell/8.jpg",
      "/img/KettleBell/9.jpg",
      "/img/KettleBell/10.jpg"
    ]
  },
  {
    id: getIDPos("Multi-Weight"),
    name: "Multi-Weight",
    description:
      "8段式重塊可調整雙手啞鈴，中間把手可轉動調整重塊，4磅到32磅的切換適合居家健身使用",
    cover: ["/img/Multi-Weight/cover.jpg"],
    imgs: [
      "/img/Multi-Weight/1.jpg",
      "/img/Multi-Weight/2.jpg",
      "/img/Multi-Weight/3.jpg",
      "/img/Multi-Weight/4.jpg",
      "/img/Multi-Weight/5.jpg",
      "/img/Multi-Weight/6.jpg",
      "/img/Multi-Weight/7.jpg"
    ]
  },
  {
    id: getIDPos("AirMate"),
    name: "AirMate",
    description: "與義大利設計師合作的創新打氣筒，創新結構可加速產線組裝",
    cover: ["/img/AirMate/cover.jpg"],
    imgs: [
      "/img/AirMate/1.jpg",
      "/img/AirMate/2.jpg",
      "/img/AirMate/3.jpg",
      "/img/AirMate/4.jpg",
      "/img/AirMate/5.jpg",
      "/img/AirMate/6.jpg",
      "/img/AirMate/7.jpg",
      "/img/AirMate/8.jpg"
    ]
  },
  {
    id: getIDPos("CFL-228"),
    name: "CFL-228",
    description: "創新結構打氣筒，可加速產線組裝，打氣筒外觀更簡潔清爽",
    cover: ["/img/CFL-228/cover.jpg"],
    imgs: ["/img/CFL-228/2.jpg", "/img/CFL-228/3.jpg", "/img/CFL-228/4.jpg"]
  },
  {
    id: getIDPos("BikeRepairStand"),
    name: "BikeRepairStand",
    description: "可收折式自行車維修架",
    cover: ["/img/BikeRepairStand/cover.jpg"],
    imgs: [
      "/img/BikeRepairStand/1.jpg",
      "/img/BikeRepairStand/2.jpg",
      "/img/BikeRepairStand/3.jpg"
    ]
  },
  {
    id: getIDPos("XEZhead"),
    name: "XEZhead",
    description:
      "美法共用按壓式打氣筒風嘴頭，取代傳統的板手型態，無扳手較不易傷害使用者",
    cover: ["/img/XEZhead/cover.jpg"],
    imgs: [
      "/img/XEZhead/1.png",
      "/img/XEZhead/2.jpg",
      "/img/XEZhead/3.jpg",
      "/img/XEZhead/4.jpg"
    ]
  },
  {
    id: getIDPos("DogYearGift"),
    name: "DogYearGift",
    description:
      "2018狗年紀念品，以拳師犬為象徵，加在風嘴頭的扳手上，材質使用不鏽鋼脫蠟鑄造。在金屬汽缸刻上顧客的姓名，別具紀念價值。",
    cover: ["/img/DogYearGift/cover.jpg"],
    imgs: [
      "/img/DogYearGift/1.jpg",
      "/img/DogYearGift/2.jpg",
      "/img/DogYearGift/3.jpg",
      "/img/DogYearGift/4.jpg",
      "/img/DogYearGift/5.jpg",
      "/img/DogYearGift/6.jpg",
      "/img/DogYearGift/7.jpg",
      "/img/DogYearGift/8.jpg",
      "/img/DogYearGift/9.jpg"
    ]
  },
  {
    id: getIDPos("FlipGaugePump"),
    name: "FlipGaugePump",
    description:
      "首創可旋轉收折壓力表打氣筒，為商家節省更多庫存空間。創新結構組裝也更能在產線上發揮節省時間人力的作用",
    cover: ["/img/FlipGaugePump/cover.jpg"],
    imgs: [
      "/img/FlipGaugePump/1.jpg",
      "/img/FlipGaugePump/2.jpg",
      "/img/FlipGaugePump/3.jpg",
      "/img/FlipGaugePump/4.jpg"
    ]
  },
  {
    id: getIDPos("AirMagnum"),
    name: "AirMagnum",
    description: "電動打氣機",
    cover: ["/img/AirMagnum/cover.jpg"],
    imgs: ["/img/AirMagnum/1.jpg", "/img/AirMagnum/2.jpg"]
  },
  {
    id: getIDPos("PixoTest"),
    name: "PixoTest",
    description: "應用傳統使用試紙的排卵檢測，在手機上能夠紀錄最佳峰期。",
    cover: ["/img/PixoTest/cover.jpg"],
    imgs: [
      "/img/PixoTest/1.jpg",
      "/img/PixoTest/2.jpg",
      "/img/PixoTest/3.jpg",
      "/img/PixoTest/4.jpg",
      "/img/PixoTest/5.jpg"
    ]
  },
  {
    id: getIDPos("EZmug"),
    name: "EZmug",
    description: "雙層不鏽鋼杯",
    cover: ["/img/EZmug/cover.jpg"],
    imgs: [
      "/img/EZmug/1.jpg",
      "/img/EZmug/2.jpg",
      "/img/EZmug/3.jpg",
      "/img/EZmug/4.jpg",
      "/img/EZmug/5.jpg",
      "/img/EZmug/6.jpg",
      "/img/EZmug/7.jpg",
      "/img/EZmug/8.jpg",
      "/img/EZmug/9.jpg",
      "/img/EZmug/10.jpg"
    ]
  },
  {
    id: getIDPos("DAB-Stereo"),
    name: "DAB-Stereo",
    description:
      "雙聲道DAB藍芽喇叭，可掃頻一千多個頻道，轉盤與按鈕的Wireframe也是設計的一部分",
    cover: ["/img/DAB-Stereo/cover.jpg"],
    imgs: [
      "/img/DAB-Stereo/1.jpg",
      "/img/DAB-Stereo/2.jpg",
      "/img/DAB-Stereo/3.jpg",
      "/img/DAB-Stereo/4.jpg"
    ]
  },
  {
    id: getIDPos("eSPORT"),
    name: "eSPORT",
    description: "攜帶型單聲道藍芽喇叭",
    cover: ["/img/eSPORT/cover.jpg"],
    imgs: [
      "/img/eSPORT/banner.jpg",
      "/img/eSPORT/1.jpg",
      "/img/eSPORT/2.jpg",
      "/img/eSPORT/3.jpg",
      "/img/eSPORT/4.jpg",
      "/img/eSPORT/5.jpg",
      "/img/eSPORT/6.jpg"
    ]
  },
  {
    id: getIDPos("DuracellHDD"),
    name: "DuracellHDD",
    description:
      "2.5吋HDD硬碟盒，以既有的勁量電池分割比例形成立體的產品識別做的外觀設計。",
    cover: ["/img/DuracellHDD/cover.jpg"],
    imgs: [
      "/img/DuracellHDD/1.jpg",
      "/img/DuracellHDD/2.jpg",
      "/img/DuracellHDD/3.jpg",
      "/img/DuracellHDD/4.jpg",
      "/img/DuracellHDD/5.jpg"
    ]
  },
  {
    id: getIDPos("WindLionGod"),
    name: "WindLionGod",
    description: "與故宮合作設計的風獅爺意象存錢筒",
    cover: ["/img/WindLionGod/cover.jpg"],
    imgs: [
      "/img/WindLionGod/0.jpg",
      "/img/WindLionGod/1.jpg",
      "/img/WindLionGod/2.jpg",
      "/img/WindLionGod/3.jpg",
      "/img/WindLionGod/4.jpg",
      "/img/WindLionGod/5.jpg"
    ]
  },
  {
    id: getIDPos("Rii"),
    name: "Rii",
    description:
      "本創作核心以設計為主，先概述設計與產品生命週期各階段的各別關係，並且透過設計的力量，正如無用設計裡面所提到的將不需要的東西重新變回到有使用價值的日常物品，無論它是社會的、文化的、感情的、功能的、經濟的、商業的、或智性的價值。同時也做出正面的貢獻與改變，還能維持平衡持久的環境。將看似無用的廢棄物可以轉化成有趣的、計畫過的、富含想像力的設計或產品。本創作主題，可量產的回收概念設計創作，提出量產讓垃圾量減的想法，舉辦主題為 Rii Design Recycle Collection 的創作展覽，把廢棄物再度返回到消費者的眼前，讓大家用感官看到環保觸摸到環保，並且思考，讓廢棄物背後的價值提升到另一條途徑。",
    cover: ["/img/Rii/cover.jpg"],
    imgs: [
      "/img/Rii/1.jpg",
      "/img/Rii/2.jpg",
      "/img/Rii/3.jpg",
      "/img/Rii/4.jpg",
      "/img/Rii/5.jpg",
      "/img/Rii/6.jpg",
      "/img/Rii/7.jpg",
      "/img/Rii/8.jpg"
    ]
  },
  {
    id: getIDPos("TonTon"),
    name: "TonTon",
    description:
      "這是一款 ESG 精神的環保概念痠痛貼布，它可以重複使用200次，它是一個創新材料的全新發明，在經過設計提案後，選定一款做為量產的基礎，也設計了收納盒，確保重複使用的機能完整。",
    cover: ["/img/TonTon/cover.jpg"],
    imgs: [
      "/img/TonTon/1.jpg",
      "/img/TonTon/2.jpg",
      "/img/TonTon/3.jpg",
      "/img/TonTon/4.jpg",
      "/img/TonTon/5.jpg",
    ]
  },
  {
    id: getIDPos("RooCare"),
    name: "RooCare",
    description:
      "大健康醫療概念產品，使用不鏽鋼絲加熱，有眼罩、暖宮片以及理療墊。為這個系列打造統一的產品識別，用同樣的弧度去應用在不同的幾何體上，創造出相似的花紋，隨機的變化讓人看不膩。",
    cover: ["/img/RooCare/cover.jpg"],
    imgs: [
      "/img/RooCare/1.jpg",
      "/img/RooCare/2.jpg",
      "/img/RooCare/3.jpg",
    ]
  },
  {
    id: getIDPos("Worthon"),
    name: "Worthon",
    description:
      "為綠巨酶公司打造了沃森科技的系列產品，執行了沃森科技的品牌命名到品牌的 CIS 、家用廚餘機、商用廚餘機。並且設計了產品的包裝還有商用廚餘機的使用者介面。",
    cover: ["/img/Worthon/cover.jpg"],
    imgs: [
      "/img/Worthon/1.jpg",
      "/img/Worthon/2.jpg",
      "/img/Worthon/3.jpg",
      "/img/Worthon/4.jpg",
      "/img/Worthon/5.jpg",
    ]
  }
];

export default productsConfig;